/**
 * MEETING BOOKING LINK — PLACEHOLDER.
 * Replace this value with the real booking URL (e.g. your Calendly / HubSpot meetings link).
 * Until it is replaced, the "Book a 20-minute introduction" button does nothing.
 */
export const BOOKING_URL = 'REPLACE_WITH_BOOKING_URL';
export const isBookingConfigured = /^https?:\/\//.test(BOOKING_URL);

export const clients = ['Roche', 'GSK', 'CSL', 'Novartis'];

export const conceptSections = [
  {
    label: 'The challenge',
    body: 'Physicians already know Poteligeo. Many have formed opinions and established treatment habits.',
  },
  {
    label: 'The opportunity',
    body: 'Meaningful new clinical evidence gives specialists a professional reason to revisit established perceptions and consider what the latest findings could mean for their patients.',
  },
  {
    label: 'The idea',
    body: 'Use the newly announced German MINT results as inspiration for a short, interactive scientific experience that makes the evidence accessible, explores its clinical relevance and connects it to specific patient populations.',
  },
];

export const conceptAmbition = {
  label: 'The ambition',
  lead: 'Not another product presentation.',
  emphasis: 'A reason to reconsider.',
};

export const opportunities = [
  { title: 'What if it’s not eczema?', detail: 'Earlier CTCL recognition.' },
  { title: 'When disease goes beyond the skin', detail: 'Understanding blood involvement.' },
  { title: 'The right patient. The right moment.', detail: 'Patient selection and sequencing.' },
  { title: 'Progression or treatment-related rash?', detail: 'Treatment-management confidence.' },
  { title: 'From trial to real world', detail: 'Connecting scientific and real-world evidence.' },
];
